
import weather from "~/mixin/weather-mixin";
export default {
  name: "cal-weather",
  mixins: [weather],
  async created() {
    // move weather API from delivery-date-selection component because of unnecessary Invoke mechanism
    await this.queryWeatherData(sessionStorage.deliveryDate);
    await this.onInit();
    this.$nuxt.$on("deliveryDateUpdated", async (date) => {
      await this.queryWeatherData(date);
      this.updateWeather();
    });
  },
  data() {
    return {
      weather: "",
      temperature: "",
      temperatureText: "",
      img: "",
      weatherObj: { ...this.$store.state.cartItem.weather } || new Object(),
    };
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  methods: {
    async queryWeatherData(deliveryDate) {
      if (
        sessionStorage.deliveryTown == undefined ||
        sessionStorage.deliveryTown == "{}"
      )
        return;
      let weatherResponse = await this.$axios.$get(
        `/weather/${JSON.parse(sessionStorage.deliveryTown).regionTag}`,
        {
          headers: {
            "callia-lang": this.$i18n.getLocaleCookie(),
          },
        }
      );

      if (weatherResponse) {
        await this.setWeather(weatherResponse, deliveryDate);
      }
    },
    onInit() {
      this.weather = this.weatherObj.weatherType
        ? this.weatherObj.weatherType
        : sessionStorage.weather
        ? sessionStorage.weather
        : "";
      this.temperature = this.isWinter()
        ? ""
        : this.weatherObj.temperature
        ? this.weatherObj.temperature
        : sessionStorage.temperature
        ? sessionStorage.temperature
        : "";
      this.img = this.isWinter()
        ? this.getWeatherIcon("snow")
        : this.getWeatherIcon(this.weather.toLowerCase());
      this.temperatureText = this.isWinter()
        ? "weather_cold"
        : this.getWeatherText(Number(this.temperature));
      this.weatherObj = {
        weatherType: this.weather,
        temperature: this.temperature,
      };
      this.$store.dispatch("cartItem/ADD_WEATHER", { ...this.weatherObj });
    },
    updateWeather() {
      this.weather = sessionStorage.weather ? sessionStorage.weather : "";
      this.temperature = this.isWinter()
        ? ""
        : sessionStorage.temperature || "";
      this.img = this.isWinter()
        ? this.getWeatherIcon("snow")
        : this.getWeatherIcon(this.weather.toLowerCase());
      this.temperatureText = this.isWinter()
        ? "weather_cold"
        : this.getWeatherText(Number(this.temperature));
      this.weatherObj = {
        weatherType: this.weather,
        temperature: this.temperature,
      };
      this.$store.dispatch("cartItem/ADD_WEATHER", { ...this.weatherObj });
    },
    isWeatherAvailable() {
      let re =
        (this.weather != undefined || this.weather !== "") &&
        this.weather.length > 0 &&
        this.temperature.length >= 0;
      return re;
    },
    isWinter() {
      const dateNow = sessionStorage.deliveryDate || new Date();
      // TODO proper date check solution for winter
      return this.$dayjs(dateNow).isBefore("2022-03-31");
    },
  },
};
